import TargetMatcher from "../../../match/TargetMatcher"
import { TargetRule } from "../../../../model/model"
import ExperimentLocalEvaluateRequest from "../mode/local/ExperimentLocalEvaluateRequest"
import { EvaluatorContext } from "../../../evaluator/Evaluator"

export default class ExperimentTargetRuleDeterminer {
  constructor(private readonly targetMatcher: TargetMatcher) {}

  determineTargetRuleOrNull(
    request: ExperimentLocalEvaluateRequest,
    context: EvaluatorContext
  ): TargetRule | undefined {
    return request.experiment.targetRules.find((it) => this.targetMatcher.matches(request, context, it.target))
  }
}
